import React, { useContext } from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  Typography,
  Container,
  Paper,
  Button
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Helmet } from "react-helmet";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ColorModeContext from "../../layout/themeContext";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#f4f6f8",
    padding: theme.spacing(4, 2),
  },
  paper: {
    padding: theme.spacing(4),
    maxWidth: 800,
    margin: "0 auto",
    borderRadius: 12,
  },
  header: {
    marginBottom: theme.spacing(4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center"
  },
  logo: {
    height: "50px",
    width: "auto",
    marginBottom: theme.spacing(2)
  },
  title: {
    fontWeight: 700,
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(1),
  },
  section: {
    marginBottom: theme.spacing(4),
  },
  sectionTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(2),
    color: "#333",
  },
  text: {
    color: "#555",
    lineHeight: 1.6,
    marginBottom: theme.spacing(2),
  },
  backButton: {
    alignSelf: "flex-start",
    marginBottom: theme.spacing(2),
  }
}));

const Terms = () => {
  const classes = useStyles();
  const { colorMode } = useContext(ColorModeContext);
  
  const appName = colorMode.appAppName || "Multizap";
  const logoSrc = colorMode.appLogoLight || colorMode.appLogoFavicon;

  return (
    <div className={classes.root}>
      <Helmet>
        <title>Termos de Uso - {appName}</title>
      </Helmet>

      <Container maxWidth="md">
        <Button
          component={RouterLink}
          to="/login"
          startIcon={<ArrowBackIcon />}
          className={classes.backButton}
          color="primary"
        >
          Voltar para o Login
        </Button>

        <Paper className={classes.paper} elevation={2}>
          <div className={classes.header}>
            {logoSrc && <img src={logoSrc} alt={appName} className={classes.logo} />}
            <Typography variant="h4" className={classes.title}>
              Termos de Uso
            </Typography>
            <Typography variant="subtitle1" color="textSecondary">
              Última atualização: {new Date().toLocaleDateString('pt-BR')}
            </Typography>
          </div>

          <div className={classes.section}>
            <Typography variant="h6" className={classes.sectionTitle}>
              1. Aceitação dos Termos
            </Typography>
            <Typography className={classes.text}>
              Ao acessar e usar a plataforma {appName}, você concorda em cumprir e ser regido por estes Termos de Uso. Se você não concordar com qualquer parte destes termos, você não deve usar nossos serviços.
            </Typography>
          </div>

          <div className={classes.section}>
            <Typography variant="h6" className={classes.sectionTitle}>
              2. Uso da Plataforma
            </Typography>
            <Typography className={classes.text}>
              O {appName} fornece ferramentas para automação, multiatendimento e gestão de conversas através de canais como WhatsApp, Facebook e Instagram. Você é responsável por garantir que o uso da nossa plataforma esteja em conformidade com as leis e os termos de serviço das plataformas integradas (ex: WhatsApp/Meta).
            </Typography>
            <Typography className={classes.text}>
              A violação das políticas do WhatsApp (como o envio de SPAM ou mensagens não solicitadas) é de sua inteira responsabilidade, isentando o {appName} de qualquer penalização, suspensão ou bloqueio do seu número de telefone.
            </Typography>
          </div>

          <div className={classes.section}>
            <Typography variant="h6" className={classes.sectionTitle}>
              3. Conta e Segurança
            </Typography>
            <Typography className={classes.text}>
              Você é responsável por manter a confidencialidade de suas credenciais de login e por todas as atividades que ocorram sob sua conta. O {appName} não se responsabiliza por perdas e danos resultantes do acesso não autorizado à sua conta.
            </Typography>
          </div>

          <div className={classes.section}>
            <Typography variant="h6" className={classes.sectionTitle}>
              4. Assinaturas e Pagamentos
            </Typography>
            <Typography className={classes.text}>
              Os serviços do {appName} são fornecidos mediante assinatura (Planos). O serviço continuará ativo desde que as mensalidades estejam regularizadas conforme o plano escolhido no ato da contratação. A conta poderá ser suspensa em caso de inadimplência após os avisos prévios.
            </Typography>
          </div>

          <div className={classes.section}>
            <Typography variant="h6" className={classes.sectionTitle}>
              5. Alterações nos Termos
            </Typography>
            <Typography className={classes.text}>
              O {appName} reserva-se o direito de modificar estes termos a qualquer momento. Modificações entrarão em vigor imediatamente após sua publicação na plataforma. Seu uso contínuo implicará na aceitação dos novos termos.
            </Typography>
          </div>

        </Paper>
      </Container>
    </div>
  );
};

export default Terms;
